export default __webpack_public_path__ + "static/media/telinsta.b231983d.png";